import envSettings from "../../services/system/envSettings";
import { baseApi } from "./baseApi";
import { InitializeTokenResponse, initializeTokenResponseSchema } from "../../models/authentication/initializeToken";
import { serveResult, validateResult } from "../../services/api/serveApiResponseResult";
import { JwtRequest } from "../../models/authentication/jwtRequest";
import { LogOutIdentResponse } from "../../models/authentication/logOutIdentResponse";

export const authenticationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    initializeToken: builder.query<InitializeTokenResponse, { token: string }>({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ({
          url: `${envSettings.UTILS_API_URL}/${envSettings.INITIALIZE_TOKEN_PREF}`,
          method: "GET",
          params: {
            token: args.token,
          },
        });
        validateResult(result, initializeTokenResponseSchema);
        return serveResult<InitializeTokenResponse>(result);
      },
      keepUnusedDataFor: 0,
    }),
    getJwt: builder.query<InitializeTokenResponse, JwtRequest>({
      async queryFn(args, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ({
          url: `${envSettings.UTILS_API_URL}/${envSettings.JWT}`,
          method: "POST",
          params: {
            ...args,
          },
        });
        validateResult(result, initializeTokenResponseSchema);
        return serveResult<InitializeTokenResponse>(result);
      },
      keepUnusedDataFor: 0,
    }),
    logOutIdent: builder.query<LogOutIdentResponse, void>({
      async queryFn(_, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ({
          url: `${envSettings.UTILS_API_URL}/${envSettings.LOG_OUT_IDENT}`,
        });
        return serveResult<LogOutIdentResponse>(result);
      },
    }),
  }),
});
export const { useLazyInitializeTokenQuery, useLazyGetJwtQuery, useLogOutIdentQuery } = authenticationApi;
